module.exports = __webpack_public_path__ + "img/fj.97102b6c.svg";